import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
 
  },
  {
    path: 'booking-room',
    loadChildren: () => import('./booking-room/booking-room.module').then(m => m.BookingRoomPageModule)
  },
  {
    path: 'splash-screen',
    loadChildren: () => import('./splash-screen/splash-screen.module').then(m => m.SplashScreenPageModule)
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)

  },
  {
    path: 'dietmeal',
    loadChildren: () => import('./dietmeal/dietmeal.module').then(m => m.DietmealPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfilePageModule)
  },
  {
    path: 'appointments',
    loadChildren: () => import('./appointments/appointments.module').then(m => m.AppointmentsPageModule)
  },
  {
    path: 'lab',
    loadChildren: () => import('./lab/lab.module').then(m => m.LabPageModule)
  },
  {
    path: 'payment',
    loadChildren: () => import('./payment/payment.module').then(m => m.PaymentPageModule)
  },
  {
    path: 'report',
    loadChildren: () => import('./report/report.module').then(m => m.ReportPageModule)
  },
  {
    path: 'speciality',
    loadChildren: () => import('./speciality/speciality.module').then(m => m.SpecialityPageModule)
  },
  {
    path: 'doctors-list',
    loadChildren: () => import('./doctors-list/doctors-list.module').then(m => m.DoctorsListPageModule)
  },
  {
    path: 'doc-appointment',
    loadChildren: () => import('./doc-appointment/doc-appointment.module').then(m => m.DocAppointmentPageModule)
  },
  {
    path: 'booking-conf',
    loadChildren: () => import('./booking-conf/booking-conf.module').then(m => m.BookingConfPageModule)
  },
  {
    path: 'training-center',
    loadChildren: () => import('./training-center/training-center.module').then(m => m.TrainingCenterPageModule)
  },
  {
    path: 'notification',
    loadChildren: () => import('./notification/notification.module').then(m => m.NotificationPageModule)
  },
  {
    path: 'prescription',
    loadChildren: () => import('./prescription/prescription.module').then(m => m.PrescriptionPageModule)
  },
  {
    path: 'shopping',
    loadChildren: () => import('./shopping/shopping.module').then(m => m.ShoppingPageModule)
  },
  {
    path: 'nursing',
    loadChildren: () => import('./nursing/nursing.module').then(m => m.NursingPageModule)
  },
  {
    path: 'nurse-booking',
    loadChildren: () => import('./nurse-booking/nurse-booking.module').then(m => m.NurseBookingPageModule)
  },
  {
    path: 'trainer',
    loadChildren: () => import('./trainer/trainer.module').then(m => m.TrainerPageModule)
  },
  {
    path: 'physiotherapy',
    loadChildren: () => import('./physiotherapy/physiotherapy.module').then(m => m.PhysiotherapyPageModule)
  },
  {
    path: 'pregnant-mother',
    loadChildren: () => import('./pregnant-mother/pregnant-mother.module').then(m => m.PregnantMotherPageModule)
  },
  {
    path: 'medication',
    loadChildren: () => import('./medication/medication.module').then(m => m.MedicationPageModule)
  },
  {
    path: 'health-tips',
    loadChildren: () => import('./health-tips/health-tips.module').then(m => m.HealthTipsPageModule)
  },
  {
    path: 'pregmother-prescription',
    loadChildren: () => import('./pregmother-prescription/pregmother-prescription.module').then(m => m.PregmotherPrescriptionPageModule)
  },
  {
    path: 'camera',
    loadChildren: () => import('./camera/camera.module').then(m => m.CameraPageModule)
  },
  {
    path: 'gps',
    loadChildren: () => import('./gps/gps.module').then(m => m.GpsPageModule)
  },
  {
    path: 'tab4',
    loadChildren: () => import('./tab4/tab4.module').then(m => m.Tab4PageModule)
  },
  {
    path: 'chat',
    loadChildren: () => import('./chat/chat.module').then(m => m.ChatPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'advance-filter',
    loadChildren: () => import('./advance-filter/advance-filter.module').then(m => m.AdvanceFilterPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'vcalert',
    loadChildren: () => import('./vcalert/vcalert.module').then(m => m.VcalertPageModule)
  },
  {
    path: 'videocall',
    loadChildren: () => import('./videocall/videocall.module').then(m => m.VideocallPageModule)
  },
  {
    path: 'cancelbooking',
    loadChildren: () => import('./cancelbooking/cancelbooking.module').then(m => m.CancelbookingPageModule)
  },
  {
    path: 'date-piker',
    loadChildren: () => import('./date-piker/date-piker.module').then(m => m.DatePikerPageModule)
  },
  {
    path: 'popupalert',
    loadChildren: () => import('./popupalert/popupalert.module').then(m => m.PopupalertPageModule)
  },
  {
    path: 'advance-filter-nurse',
    loadChildren: () => import('./advance-filter-nurse/advance-filter-nurse.module').then(m => m.AdvanceFilterNursePageModule)
  },
  {
    path: 'modpricetag',
    loadChildren: () => import('./modpricetag/modpricetag.module').then(m => m.ModpricetagPageModule)
  },
  {
    path: 'doctor-service-list',
    loadChildren: () => import('./doctor-service-list/doctor-service-list.module').then(m => m.DoctorServiceListPageModule)
  },
  {
    path: 'upload-report',
    loadChildren: () => import('./upload-report/upload-report.module').then(m => m.UploadReportPageModule)
  },
  {
    path: 'newphysiotherapy',
    loadChildren: () => import('./newphysiotherapy/newphysiotherapy.module').then(m => m.NewphysiotherapyPageModule)
  },
  {
    path: 'advertisement',
    loadChildren: () => import('./advertisement/advertisement.module').then( m => m.AdvertisementPageModule)
  },
  {
    path: 'mediapopup',
    loadChildren: () => import('./mediapopup/mediapopup.module').then( m => m.MediapopupPageModule)
  },
  {
    path: 'termscond',
    loadChildren: () => import('./termscond/termscond.module').then( m => m.TermscondPageModule)
  },
  {
    path: 'doclistmod',
    loadChildren: () => import('./appointments/doclistmod/doclistmod.module').then( m => m.DoclistmodPageModule)
  },
  {
    path: 'addmem',
    loadChildren: () => import('./addmem/addmem.module').then( m => m.AddmemPageModule)
  },
  {
    path: 'review',
    loadChildren: () => import('./review/review.module').then( m => m.ReviewPageModule)
  },
  {
    path: 'viewmodel',
    loadChildren: () => import('./viewmodel/viewmodel.module').then( m => m.ViewmodelPageModule)
  },
  {
    path: 'common-notification',
    loadChildren: () => import('./common-notification/common-notification.module').then( m => m.CommonNotificationPageModule)
  },
  {
    path: 'rating-sortpage',
    loadChildren: () => import('./rating-sortpage/rating-sortpage.module').then( m => m.RatingSortpagePageModule)
  },
  {
    path: 'vc-permission-page',
    loadChildren: () => import('./vc-permission-page/vc-permission-page.module').then( m => m.VcPermissionPagePageModule)
  },
  {
    path: 'chats',
    loadChildren: () => import('./chats/chats.module').then( m => m.ChatsPageModule)
  },
  {
    path: 'change-language',
    loadChildren: () => import('./change-language/change-language.module').then( m => m.ChangeLanguagePageModule)
  },
  {
    path: 'vaccination-schedule',
    loadChildren: () => import('./vaccination-schedule/vaccination-schedule.module').then( m => m.VaccinationSchedulePageModule)
  },
  {
    path: 'code-scanner',
    loadChildren: () => import('./code-scanner/code-scanner.module').then( m => m.CodeScannerPageModule)
  },
  {
    path: 'physio-doctors-list',
    loadChildren: () => import('./physio-doctors-list/physio-doctors-list.module').then( m => m.PhysioDoctorsListPageModule)
  },
  {
    path: 'physio-doc-appointment',
    loadChildren: () => import('./physio-doc-appointment/physio-doc-appointment.module').then( m => m.PhysioDocAppointmentPageModule)
  },
  {
    path: 'physio-booking-conf',
    loadChildren: () => import('./physio-booking-conf/physio-booking-conf.module').then( m => m.PhysioBookingConfPageModule)
  },
  {
    path: 'physio-appointment',
    loadChildren: () => import('./physio-appointment/physio-appointment.module').then( m => m.PhysioAppointmentPageModule)
  },
  {
    path: 'prescriptionpopup',
    loadChildren: () => import('./prescriptionpopup/prescriptionpopup.module').then( m => m.PrescriptionpopupPageModule)
  },
  {
    path: 'videomodal',
    loadChildren: () => import('./videomodal/videomodal.module').then( m => m.VideomodalPageModule)
  },
  {
    path: 'DefinedDutiesPage',
    loadChildren: () => import('../app/nurse-booking/defined-duties/defined-duties.module').then( m => m.DefinedDutiesPageModule)
  },
  {
    path: 'knet',
    loadChildren: () => import('./knet/knet.module').then( m => m.KnetPageModule)
  },  {
    path: 'success',
    loadChildren: () => import('./success/success.module').then( m => m.SuccessPageModule)
  },


  
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
